import { createLog, LogSeverity } from '../../../utils/createLog.js';
import { registerServiceProvider } from '../ServiceProviderRegistry.js';
import { Services } from './Services.js';
import { servicesProviderFreightDataSchema } from './ServicesProviderFreightData.js';
import { PayableServicesProvider } from './ServicesProviderPayable.js';

class ServicesProviderFreight extends PayableServicesProvider {
    constructor(data) {
        super(data);
        this.validateData(data);
    }
    validateData(data) {
        const result = servicesProviderFreightDataSchema.safeParse(data);
        if (!result.success) {
            createLog('ServicesProviderFreight.validation', `ServicesProviderFreight data validation failed for svp id ${data.id}: ${result.error.message}`, LogSeverity.ERROR, {
                service: Services.FREIGHT,
                errors: result.error.errors,
            });
            // TODO: change to throw error once db is cleaned up
            return data;
        }
        return result.data;
    }
}
// Register this subclass with ServicesProvider
registerServiceProvider(Services.FREIGHT, ServicesProviderFreight);

export { ServicesProviderFreight };
//# sourceMappingURL=ServicesProviderFreight.js.map
